// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"288":"c5904c26","875":"d01aee39"}[chunkId] + ".chunk.css";
};